import calculateMinMax from './calculate-min-max';

const getRangeValue = (rawQueryProp, rangeInterval, _min, _max) => {
  const { min, max } = calculateMinMax({ min: _min, max: _max }, rangeInterval);
  const defaultValues = {
    max,
    min,
    step: rangeInterval,
    maxValue: max,
    minValue: min
  };
  if (rawQueryProp) {
    const [queryParamMin, queryParamMax] = Array.isArray(rawQueryProp)
      ? rawQueryProp[0].split('-')
      : rawQueryProp.split('-');
    const updatedMinValue = Number(queryParamMin);
    const updatedMaxValue = Number(queryParamMax);

    if (Number.isNaN(updatedMinValue) || Number.isNaN(updatedMaxValue)) return defaultValues;

    return {
      min: Number.isNaN(min) ? updatedMinValue : min,
      max: Number.isNaN(max) ? updatedMaxValue : max,
      step: rangeInterval,
      maxValue: updatedMaxValue,
      minValue: updatedMinValue
    };
  }

  return defaultValues;
};

export default getRangeValue;
